// - [ ] Adjust player to be large with aspect ratio so overlay isn't on black for position consistency.
// - [ ] One overlay-component? Or one overlay component per video instance?
<template>
  <transition name='fade'>
  <div @click="watchClick($event)"
    v-show='render_hotspot && showHotspots && !overlapped && !hideUncollapsableHotspot'
    :tabindex="render_hotspot && showHotspots && !overlapped ? 0 : -1" 
    :id="'hotspot_' + interaction.id"
    :class="{
      collapsed: interactionMeta.collapsed,
      expanded: interactionMeta.expanded,
      'v-card': interactionMeta.opacity === 1,
    }"
    :style="[overlayPosition, opacityStyle]"
    class="hotspot"
    role="dialog"
    aria-labelledby="Hotspot Overlay"
    >
    <div v-if='allowCollapse' class="hs-action collapse">
      <v-btn flat small class="ma-0" icon @click='collapse' :aria-label="(interactionMeta.collapsed ? 'Show' : 'Collapse') + ' Hotspot ' + (stackIndex + 1)">
        <v-icon size="18" color="interactionMeta.darkMode ? 'white' : 'black'">{{collapsed ? 'add' : 'close' }}</v-icon>
      </v-btn>
    </div>
    <div v-if='allowExpand' class="hs-action expand">
      <v-btn flat small class="ma-0" icon @click="expand" :aria-label="(interactionMeta.expanded ? 'Shrink' : 'Expand') + ' Hotspot ' + (stackIndex + 1)">
        <v-icon size="18" color='black'  @keyup.enter="expand">call_made</v-icon>
      </v-btn>
    </div>
    <!-- Success team doesn't know what they want for hotspot pause interactions-->
    <!--<div v-if='allowPlay' class="hs-action play-toggle branding-active">-->
    <!--  <v-btn flat small class="ma-0" icon @click="play" aria-label="Play" color="primary">-->
    <!--    <v-icon size="18" color="white">play_arrow</v-icon>-->
    <!--  </v-btn>-->
    <!--</div>-->
    <div class="hs-content grey-text text-darken-2">
      <interaction-wrapper :interaction-id='interaction.id' :key="vue_key"></interaction-wrapper>
    </div>
  </div>
  </transition>
</template>

<script>

// [ ] all overlay questions are getting generated on page load. Need better way to handle persistance
// [ ] hotspots themselves are correctly fading with exit transition but the question wrapper inside them has no transition and create a hard cut to display none.
import InteractionWrapper from './interaction/InteractionWrapper';
import EventBus from '@/buses/EventBus';
/* eslint-disable */
import { mapState, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'hotspot',
  components: {
    InteractionWrapper,
  },
  props: [
    'interaction',
    'stackIndex',

  ],
  data() {
    return {
      expanded:false,
      collapsed: false,
    };
  },
  computed: {
    ...mapState('player', [
      'showHotspots',
    ]),
    ...mapState('interactions', [
      'hotspotPositionsArray',
    ]),
    ...mapGetters('player', [
      'minSidebarPx',
      'playerState',
    ]),
    ...mapGetters('interactions', [
      'incompleteHotspots',
    ]),
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interaction.id) || {};
    },
    allowExpand() {
      // whether or not to display the expand icon on hotspots, defaults to true
      if (_.has(this.interaction,'position.expand')) {
        return this.interaction.position.expand;
      }
      return true;
    },
    allowCollapse() {
      // if hotspot has preset for collapse
      if (_.has(this.interaction,'position.collapse')) {
        // hotspot specficially prevents collapse
        if (!this.interaction.position.collapse) {
          return false;
        } else {
          // cannot hide a required, unanswered interaction
          if (this.interaction.isRequired && !this.interactionMeta.isInteractionAnswered) {
            return false;
          } else {
            return true;
          }
        }
      }
      // hotspot doesn't have preset for collapse
      // cannot hide a required unanswered interaction
      if (this.interaction.required && !this.interactionMeta.isInteractionAnswered) {
        return false;
      }
      // otherwise cool
      return true;
    },
    // allowPlay() { // Success team doesn't know what they want for hotspot pause interactions
    //   return this.interaction.interactionType === "pause_q" && this.incompleteHotspots === 0 && this.playerState === 'paused';
    // },
    opacityStyle() {
      if (this.interactionMeta.darkMode) {
        return { background: `rgba(0, 0, 0, ${this.interactionMeta.opacity})`};
      }
      return { background: `rgba(255, 255, 255, ${this.interactionMeta.opacity})` };
    },
    overlapped() {
      const thisHotspotRect = _.find(this.hotspotPositionsArray, { 'id': this.interaction.id });
      const interactionIndex = _.findIndex(this.hotspotPositionsArray, { 'id': this.interaction.id });
      let overlapped = false;
      for (const [index, hotspot] of this.hotspotPositionsArray.entries()) {
        if (hotspot.id !== this.interaction.id && index < interactionIndex && this.$store.getters['interactions/interactionMeta'](hotspot.id).inDisplayRange) {
          if (
              !(thisHotspotRect.right <= hotspot.left
              || thisHotspotRect.left >= hotspot.right
              || thisHotspotRect.bottom <= hotspot.top
              || thisHotspotRect.top >= hotspot.bottom)
              && !this.$store.getters['interactions/interactionMeta'](hotspot.id).collapsed) {
                overlapped = true;
                break;
              }
        }
      }
      return overlapped;
    },
    overlayPosition() {
      const top = this.interaction.position.top;
      const left = this.interaction.position.left;
      const width =  this.collapsed ? '5px' : this.interaction.position.width;
      const height = this.collapsed ? '5px' : this.interaction.position.height;
      const zIndex = (1000 - this.stackIndex) + 10;
      return {top, left, width, height, zIndex}
    },
    render_hotspot() {
      return this.interactionMeta.inDisplayRange  && !this.interactionMeta.hiddenByRequired;
    },
    hideUncollapsableHotspot() {
      // Ducttape to instantly hide a hotspot (skip transition) for collapse: false HotSpots
      if (!_.get(this, 'interaction.position.collapse', false) && _.get(this, 'interactionMeta.collapsed', false)) return true;
      return false;
    },
    vue_key() {
      return `q_${this.sidebar ? 's_' : ''}${this.interaction.id}`;
    },
  },
  methods: {
    ...mapMutations('player', [
      'setManualPlay',
      'setManualPause',
    ]),
    ...mapMutations('interactions', [
      'removeHotspotPosition',
      'updateHotspotPositionsArray',
    ]),
    collapse() {
      this.interactionMeta.collapsed = !this.interactionMeta.collapsed;
    },
    expand() {
      this.interactionMeta.expanded = !this.interactionMeta.expanded;
    },
    // play() { // Success team doesn't know what they want for hotspot pause interactions
    //   EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
    // },
    watchClick(e)  {
      if (this.interaction.position.opacity === 0) {
        // clicking on something that isn't a input field needs to trigger a play/pause
        const jump = e.target.closest('[data-pp-jump], .hs-action');
        const input = e.target.closest('input, .radio-option, .checkbox-option, textarea')
        const qType = e.target.closest('.discussion-question, [type="button"]')
        if (!jump && !input && !qType) {
          e.preventDefault();
          if (this.playerState === 'paused') {
            this.setManualPlay(true);
            EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
          } else {
            this.setManualPause(true);
            EventBus.$emit('requestAction', { key: 'pause', setDesiredState: true });
          }
        }
      }
    }
  },
  watch: {
    'render_hotspot'(n,o) {
      if(this.render_hotspot) {
        // set session temp time
        this.interactionMeta.sessionStartTime = moment();
        this.interactionMeta.collapsed = false; // if set during !renderHotspot the would start to expand and then collapse again causing a flash on the screen.
      }
      else {
        this.interactionMeta.tempSessionTime += moment.duration(moment().diff(this.interactionMeta.sessionStartTime)).asSeconds()
        this.sessionStartTime = null;
      }
    },
  },
  mounted() {
    this.updateHotspotPositionsArray(
        {
          id: this.interaction.id,
          top: parseFloat(this.interaction.position.top),
          left: parseFloat(this.interaction.position.left),
          right: parseFloat(this.interaction.position.left) + parseFloat(this.interaction.position.width),
          bottom: parseFloat(this.interaction.position.top) + parseFloat(this.interaction.position.height),
        }
      );
  },
};
</script>

<style>
  .hotspot {
    pointer-events: auto;
    opacity: 1;
    z-index: 10;
    position: absolute !important;
    -webkit-transition: width .5s, height .5s, top .5s, left .5s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: width .5s, height .5s, top .5s, left .5s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  .hotspot.expanded {
    top:0 !important;
    left:0 !important;
    width: 100% !important;
    height: 100% !important;
  }
  .hotspot.collapsed {
    width: 18px !important;
    height: 18px !important;
    border-radius: 50%;
    transition: border-radius .5s  cubic-bezier(0.25, 0.8, 0.5, 1);
    z-index: 1 !important;
  }
  .hs-action {
    position: absolute;
    opacity: 0;
    z-index: 15;
    display: flex;
    justify-content: center;
    background: white;
    border-radius: 50% !important;
    transition: opacity 0.2s ease;
  }

  .hs-action button {
    width: 18px !important;
    height: 18px !important;
  }

  .hs-action:hover{
    cursor: pointer;
  }
  .hotspot:hover .hs-action{
    opacity: .8;
  }

  .secondary-stream-default-hls-caption-button {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .hotspot:hover .secondary-stream-default-hls-caption-button {
    opacity: .8;
  }

  .hotspot:hover .hs-action:hover i, .hs-action:focus {
    opacity: 1;
  }
  #overlay-container .hotspot .hs-content iframe{
    max-width: 100%;
    display: block; /* removed 5 pixels at bottom of iframe */
  }
  .hs-action.expand {
    /* Success team doesn't know what they want for hotspot pause interactions*/
    /*left: 18px;*/
    right: 0;
  }
  .hs-action.collapse {
    transition: transform .3s linear;
  }
  .hs-action.play-toggle {
    right: 0;
  }

  .hotspot.expanded .hs-action.expand {
    transform: scale(-1);
  }
  .hotspot.collapsed .hs-action.expand,
  .hotspot.collapsed .hs-action.play-toggle{
    display: none;
  }
  .hotspot.collapsed .hs-content {
    opacity: 0;
  }
  .hotspot.collapsed .hs-action.collapse {
    opacity: 1;
    transform: rotate(45deg);
    border-radius: 50%;
  }
  .hs-action i {
    padding: 0;
    opacity: .8;
  }
  .hs-content{
    width: 100%;
    height: 100%;
    max-width: 100% !important;
    max-height: 100% !important;
    -webkit-overflow-scrolling: touch; /* allow touch scrolling  */
  	overflow: auto;
    display:flex;
  }
  .hotspot.collapsed .hs-content {
    display: none;
  }
  .fade-enter-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
